import Resource from '@/api/resources/Resource'

class RevisionTypeServices extends Resource {
    async getAllPortionRevisionTypes() {
        const response = await this.axios.get(`/revisionTypes/portions`)
        return response.data
    }

    async getAllSampleRevisionTypes(workflow) {
        const response = await this.axios.get(`/revisionTypes/samples`, { params: { workflow } })
        return response.data
    }

    async getAllSubportionRevisionTypes() {
        const response = await this.axios.get(`/revisionTypes/subportions`)
        return response.data
    }
}

export default new RevisionTypeServices()
